import React from 'react'
import B1BenefitsHead from './B1BenefitsHead'
import B1BenefitsMain from './B1BenefitsMain'

const B1Benefits = () => {
  return (
    <div className='lvlBenefitsContainer'>
      <B1BenefitsHead/>
      <B1BenefitsMain/>
    </div>
  )
}

export default B1Benefits
